export var colors = {
    cinnamon600: '#a31b12',
    cinnamon500: '#de2e21',
    cinnamon400: '#ff5347',
    cinnamon300: '#ff867d',
    cinnamon200: '#fcc9c5',
    cinnamon100: '#ffefee',
    peach600: '#b53413',
    peach500: '#de4721',
    peach400: '#ff643d',
    peach300: '#ff957a',
    peach200: '#ffc2b3',
    peach100: '#fff3f0',
    chiliMango600: '#a33600',
    chiliMango500: '#e04b00',
    chiliMango400: '#ff671b',
    chiliMango300: '#ff9b69',
    chiliMango200: '#ffc7ab',
    chiliMango100: '#ffe6d9',
    cantaloupe600: '#c06c00',
    cantaloupe500: '#f38b00',
    cantaloupe400: '#ffa126',
    cantaloupe300: '#ffbc63',
    cantaloupe200: '#fcd49f',
    cantaloupe100: '#ffeed9',
    sourLemon600: '#bd9100',
    sourLemon500: '#ebb400',
    sourLemon400: '#ffc629',
    sourLemon300: '#ffda61',
    sourLemon200: '#ffecab',
    sourLemon100: '#fff9e6',
    juicyPear600: '#687818',
    juicyPear500: '#8ea618',
    juicyPear400: '#a8c224',
    juicyPear300: '#c4de40',
    juicyPear200: '#e2f391',
    juicyPear100: '#f7fae6',
    kiwi600: '#537824',
    kiwi500: '#609915',
    kiwi400: '#77bc1f',
    kiwi300: '#a7e05c',
    kiwi200: '#caf593',
    kiwi100: '#ecfcd7',
    greenApple600: '#217a37',
    greenApple500: '#319c4c',
    greenApple400: '#43c463',
    greenApple300: '#5fe380',
    greenApple200: '#acf5be',
    greenApple100: '#ebfff0',
    watermelon600: '#00573e',
    watermelon500: '#0c7a5b',
    watermelon400: '#12a67c',
    watermelon300: '#65ccaf',
    watermelon200: '#b7edde',
    watermelon100: '#ebfdf8',
    jewel600: '#156973',
    jewel500: '#1a818c',
    jewel400: '#1ea4b3',
    jewel300: '#44c8d7',
    jewel200: '#acecf3',
    jewel100: '#ebfdff',
    toothpaste600: '#005b82',
    toothpaste500: '#0271a1',
    toothpaste400: '#1894c9',
    toothpaste300: '#40b4e5',
    toothpaste200: '#99e0ff',
    toothpaste100: '#d7f1fc',
    blueberry600: '#004387',
    blueberry500: '#005cb9',
    blueberry400: '#0875e1',
    blueberry300: '#40a0ff',
    blueberry200: '#a6d2ff',
    blueberry100: '#d7eafc',
    plum600: '#264a7a',
    plum500: '#3166ab',
    plum400: '#3881e1',
    plum300: '#529bfa',
    plum200: '#a6cdff',
    plum100: '#e6f1ff',
    berrySmoothie600: '#3b4987',
    berrySmoothie500: '#4b5eb3',
    berrySmoothie400: '#5e77e6',
    berrySmoothie300: '#7891ff',
    berrySmoothie200: '#c2cfff',
    berrySmoothie100: '#e8edff',
    blackberry600: '#2e2d91',
    blackberry500: '#413fcc',
    blackberry400: '#5c59e6',
    blackberry300: '#8483e6',
    blackberry200: '#c3c2ff',
    blackberry100: '#f0f0ff',
    islandPunch600: '#503882',
    islandPunch500: '#6345a1',
    islandPunch400: '#8660d1',
    islandPunch300: '#a88ae6',
    islandPunch200: '#d2befa',
    islandPunch100: '#f5f0ff',
    grapeSoda600: '#7c3882',
    grapeSoda500: '#97499e',
    grapeSoda400: '#c860d1',
    grapeSoda300: '#de8ae6',
    grapeSoda200: '#fac0ff',
    grapeSoda100: '#feebff',
    pomegranate600: '#99003a',
    pomegranate500: '#c70550',
    pomegranate400: '#f31167',
    pomegranate300: '#ff5c9a',
    pomegranate200: '#ffbdd6',
    pomegranate100: '#ffebf3',
    fruitPunch600: '#b82828',
    fruitPunch500: '#e12f2f',
    fruitPunch400: '#ff4c4c',
    fruitPunch300: '#ff7e7e',
    fruitPunch200: '#ffbdbd',
    fruitPunch100: '#ffeeee',
    rootBeer600: '#664d42',
    rootBeer500: '#8c7266',
    rootBeer400: '#ba9a8c',
    rootBeer300: '#dcbbad',
    rootBeer200: '#ebd7cf',
    rootBeer100: '#faf3f0',
    toastedMarshmallow600: '#8c6000',
    toastedMarshmallow500: '#b37f10',
    toastedMarshmallow400: '#cc9e3b',
    toastedMarshmallow300: '#e6bf6c',
    toastedMarshmallow200: '#ebd6a9',
    toastedMarshmallow100: '#fdf6e6',
    coconut600: '#8f8687',
    coconut500: '#9e9595',
    coconut400: '#b3acac',
    coconut300: '#d1cbcc',
    coconut200: '#e3dfdf',
    coconut100: '#f0eeee',
    cappuccino600: '#231f20',
    cappuccino500: '#352f2f',
    cappuccino400: '#4a4242',
    cappuccino300: '#5e5757',
    cappuccino200: '#706869',
    cappuccino100: '#7a7374',
    soap600: '#b9c0c7',
    soap500: '#ced3d9',
    soap400: '#dfe2e6',
    soap300: '#e8ebed',
    soap200: '#f0f1f2',
    soap100: '#f6f7f8',
    licorice600: '#1f262e',
    licorice500: '#333d47',
    licorice400: '#4a5561',
    licorice300: '#5e6a75',
    licorice200: '#7b858f',
    licorice100: '#a1aab3',
    frenchVanilla600: '#8f8f8f',
    frenchVanilla500: '#a6a6a6',
    frenchVanilla400: '#bdbdbd',
    frenchVanilla300: '#d4d4d4',
    frenchVanilla200: '#ebebeb',
    frenchVanilla100: '#ffffff',
    blackPepper600: '#000000',
    blackPepper500: '#1e1e1e',
    blackPepper400: '#333333',
    blackPepper300: '#494949',
    blackPepper200: '#616161',
    blackPepper100: '#787878',
};
export var gradients = {
    cinnamon: "linear-gradient(to bottom right," + colors.cinnamon500 + "," + colors.cinnamon400 + ")",
    peach: "linear-gradient(to bottom right," + colors.peach500 + "," + colors.peach400 + ")",
    chiliMango: "linear-gradient(to bottom right," + colors.chiliMango500 + "," + colors.chiliMango400 + ")",
    cantaloupe: "linear-gradient(to bottom right," + colors.cantaloupe500 + "," + colors.cantaloupe400 + ")",
    sourLemon: "linear-gradient(to bottom right," + colors.sourLemon500 + "," + colors.sourLemon400 + ")",
    juicyPear: "linear-gradient(to bottom right," + colors.juicyPear500 + "," + colors.juicyPear400 + ")",
    kiwi: "linear-gradient(to bottom right," + colors.kiwi500 + "," + colors.kiwi400 + ")",
    greenApple: "linear-gradient(to bottom right," + colors.greenApple500 + "," + colors.greenApple400 + ")",
    watermelon: "linear-gradient(to bottom right," + colors.watermelon500 + "," + colors.watermelon400 + ")",
    jewel: "linear-gradient(to bottom right," + colors.jewel500 + "," + colors.jewel400 + ")",
    toothpaste: "linear-gradient(to bottom right," + colors.toothpaste500 + "," + colors.toothpaste400 + ")",
    blueberry: "linear-gradient(to bottom right," + colors.blueberry500 + "," + colors.blueberry400 + ")",
    plum: "linear-gradient(to bottom right," + colors.plum500 + "," + colors.plum400 + ")",
    berrySmoothie: "linear-gradient(to bottom right," + colors.berrySmoothie500 + "," + colors.berrySmoothie400 + ")",
    blackberry: "linear-gradient(to bottom right," + colors.blackberry500 + "," + colors.blackberry400 + ")",
    islandPunch: "linear-gradient(to bottom right," + colors.islandPunch500 + "," + colors.islandPunch400 + ")",
    grapeSoda: "linear-gradient(to bottom right," + colors.grapeSoda500 + "," + colors.grapeSoda400 + ")",
    pomegranate: "linear-gradient(to bottom right," + colors.pomegranate500 + "," + colors.pomegranate400 + ")",
    fruitPunch: "linear-gradient(to bottom right," + colors.fruitPunch500 + "," + colors.fruitPunch400 + ")",
    rootBeer: "linear-gradient(to bottom right," + colors.rootBeer600 + "," + colors.rootBeer500 + ")",
    toastedMarshmallow: "linear-gradient(to bottom right," + colors.toastedMarshmallow500 + "," + colors.toastedMarshmallow400 + ")",
    cappuccino: "linear-gradient(to bottom right," + colors.cappuccino400 + "," + colors.cappuccino300 + ")",
    licorice: "linear-gradient(to bottom right," + colors.licorice500 + "," + colors.licorice400 + ")",
    blackPepper: "linear-gradient(to bottom right," + colors.blackPepper400 + "," + colors.blackPepper300 + ")",
};
export default colors;
export var chartingColors = {
    1: colors.watermelon200,
    2: colors.watermelon300,
    3: colors.jewel200,
    4: colors.jewel300,
    5: colors.plum200,
    6: colors.plum300,
    7: colors.islandPunch200,
    8: colors.islandPunch300,
    9: colors.pomegranate200,
    10: colors.pomegranate300,
    11: colors.peach200,
    12: colors.peach400,
    13: colors.cantaloupe200,
    14: colors.cantaloupe400,
    15: colors.sourLemon200,
    16: colors.sourLemon400,
    17: colors.watermelon400,
    18: colors.watermelon500,
    19: colors.jewel400,
    20: colors.jewel500,
    21: colors.plum400,
    22: colors.plum500,
    23: colors.islandPunch400,
    24: colors.islandPunch500,
    25: colors.pomegranate400,
    26: colors.pomegranate600,
    27: colors.peach500,
    28: colors.peach600,
    29: colors.cantaloupe500,
    30: colors.cantaloupe600,
    31: colors.sourLemon500,
    32: colors.sourLemon600,
    33: colors.greenApple200,
    34: colors.greenApple300,
    35: colors.toothpaste200,
    36: colors.toothpaste300,
    37: colors.blueberry200,
    38: colors.blueberry300,
    39: colors.berrySmoothie200,
    40: colors.blackberry300,
    41: colors.fruitPunch200,
    42: colors.fruitPunch300,
    43: colors.rootBeer200,
    44: colors.rootBeer300,
    45: colors.toastedMarshmallow200,
    46: colors.toastedMarshmallow400,
    47: colors.chiliMango200,
    48: colors.chiliMango400,
    49: colors.greenApple400,
    50: colors.greenApple600,
    51: colors.toothpaste400,
    52: colors.toothpaste600,
    53: colors.blueberry400,
    54: colors.blueberry600,
    55: colors.blackberry400,
    56: colors.blackberry600,
    57: colors.fruitPunch400,
    58: colors.fruitPunch600,
    59: colors.rootBeer500,
    60: colors.rootBeer600,
    61: colors.toastedMarshmallow500,
    62: colors.toastedMarshmallow600,
    63: colors.chiliMango500,
    64: colors.chiliMango600,
    65: colors.kiwi200,
    66: colors.kiwi400,
    67: colors.berrySmoothie200,
    68: colors.berrySmoothie300,
    69: colors.grapeSoda200,
    70: colors.grapeSoda300,
    71: colors.cinnamon200,
    72: colors.cinnamon300,
    73: colors.sourLemon300,
    74: colors.toastedMarshmallow300,
    75: colors.peach300,
    76: colors.cinnamon500,
    77: colors.cantaloupe300,
    78: colors.chiliMango300,
    79: colors.kiwi300,
    80: colors.kiwi500,
    81: colors.berrySmoothie400,
    82: colors.berrySmoothie500,
    83: colors.grapeSoda400,
    84: colors.grapeSoda500,
    85: colors.cinnamon400,
    86: colors.cinnamon500,
};
export var chartingColorOffsets = {
    barAndColumn: 1,
    pie: 4,
    lineAndArea: 7,
    bubble: 11,
};
export var commonColors = {
    background: colors.frenchVanilla100,
    backgroundAlt: colors.soap200,
    focusOutline: colors.blueberry400,
    focusBackground: colors.blueberry400,
    hoverBackground: colors.soap300,
    divider: colors.soap400,
};
export var buttonColors = {
    delete: {
        background: colors.cinnamon100,
        border: colors.cinnamon400,
        text: colors.cinnamon500,
        activeBackground: colors.cinnamon100,
        activeBorder: colors.cinnamon400,
        activeText: colors.cinnamon500,
        disabledBackground: colors.cinnamon100,
        disabledBorder: colors.cinnamon200,
        disabledText: colors.cinnamon300,
        focusBackground: colors.cinnamon100,
        focusBorder: colors.blueberry400,
        focusText: colors.cinnamon500,
        hoverBackground: colors.cinnamon400,
        hoverBorder: colors.cinnamon600,
        hoverText: colors.frenchVanilla100,
    },
    primary: {
        background: colors.cantaloupe400,
        border: colors.cantaloupe400,
        text: colors.frenchVanilla100,
        activeBackground: colors.cantaloupe400,
        activeBorder: colors.cantaloupe400,
        activeText: colors.frenchVanilla100,
        disabledBackground: colors.cantaloupe200,
        disabledBorder: colors.cantaloupe400,
        disabledText: colors.frenchVanilla100,
        focusBackground: colors.cantaloupe400,
        focusBorder: colors.blueberry400,
        focusText: colors.frenchVanilla100,
        hoverBackground: colors.cantaloupe500,
        hoverBorder: colors.cantaloupe400,
        hoverText: colors.frenchVanilla100,
    },
    secondary: {
        background: colors.soap200,
        border: colors.soap500,
        text: colors.blackPepper400,
        activeBackground: colors.soap200,
        activeBorder: colors.soap500,
        activeText: colors.blackPepper400,
        disabledBackground: colors.frenchVanilla100,
        disabledBorder: colors.soap500,
        disabledText: colors.soap500,
        focusBackground: colors.soap200,
        focusBorder: colors.blueberry400,
        focusText: colors.blackPepper400,
        hoverBackground: colors.soap500,
        hoverBorder: colors.licorice100,
        hoverText: colors.blackPepper400,
    },
};
export var iconColors = {
    active: colors.blueberry500,
    disabled: colors.soap600,
    hover: colors.licorice500,
    inverse: colors.frenchVanilla100,
    standard: colors.licorice200,
};
export var inputColors = {
    background: colors.frenchVanilla100,
    border: colors.licorice200,
    placeholder: colors.licorice300,
    text: colors.blackPepper300,
    icon: colors.licorice200,
    iconHover: colors.licorice500,
    selectionControlFill: colors.blueberry400,
    hoverBorder: colors.licorice500,
    focusBorder: colors.blueberry400,
    disabled: {
        background: colors.soap100,
        border: colors.soap600,
        text: colors.licorice100,
        icon: colors.soap600,
    },
    error: {
        border: colors.cinnamon500,
        message: colors.blackPepper100,
        icon: colors.cinnamon500,
    },
    alert: {
        border: colors.cantaloupe400,
        message: colors.blackPepper100,
        icon: colors.cantaloupe500,
    },
};
export var statusColors = {
    active: colors.blueberry500,
    success: colors.greenApple400,
    warning: colors.cantaloupe400,
    error: colors.cinnamon500,
};
export var typeColors = {
    body: colors.blackPepper300,
    heading: colors.blackPepper400,
    hint: colors.licorice300,
    inverse: colors.frenchVanilla100,
    label: colors.blackPepper100,
    link: colors.blueberry400,
    selectHighlight: colors.blueberry200,
    selectHighlightInverse: colors.frenchVanilla100,
};
